let contactUsIds = {
    contact_us_name_label                       :   "Hubungi kami",
    before_you_contact_us_and_continue_label    :   "Sebelum Anda menghubungi kami, kami sarankan Anda untuk memeriksa bagian FAQ kami untuk melihat apakah pertanyaan Anda telah dijawab.",
    in_case_any_query_label                     :   "Jika Anda terjebak dengan masalah unik, jangan ragu untuk menghubungi kami.",
    contact_email_label                         :   "admin.frames@oyorooms.com"
}

export default {
    ...contactUsIds
}